import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["use", "useBreezeStyles"];
import styled from 'styled-components';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getStyledAIIconButton } from './styledButtons/StyledAIBaseIconButton';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * We can only pass a number or string to UIIcon
 * We cannot use an em for relative sizing
 * To work about this we can use a transform to scale the icon
 */
const StyledIcon = styled(UIIcon).withConfig({
  displayName: "CopilotBaseIconButton__StyledIcon",
  componentId: "sc-1hu1b80-0"
})(["font-size:1.2em;margin-top:-0.1em;"]);
export function CopilotBaseIconButton(_ref) {
  let {
      use = 'tertiary-light',
      // default to tertiary-light
      useBreezeStyles
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  /** We want to allow a way for teams to still use non Breeze styling
   * This is a valid design use case where a button grouping the Breeze button will be
   * styled like the other buttons in the group
   */
  if (!useBreezeStyles) {
    return /*#__PURE__*/_jsx(UIIconButton, Object.assign({}, uiButtonProps, {
      use: use,
      children: /*#__PURE__*/_jsx(StyledIcon, {
        name: "breezeSingleStar"
      })
    }));
  }
  const AIButtonComponent = getStyledAIIconButton(use);
  return /*#__PURE__*/_jsx(AIButtonComponent, Object.assign({}, uiButtonProps, {
    use: use,
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "breezeSingleStar"
    })
  }));
}